import { useEffect, useState } from "react";
import AssistantService from "../../../services/AssistantService";
import { Assistant } from "../../../entities/company/Assistant/Assistant";

const AssistantConfiguration = () => {
    const [assistant, setAssistant] = useState<Assistant | null>(null);
    const [instructions, setInstructions] = useState("");
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [success, setSuccess] = useState(false);

    useEffect(() => {
        const fetchAssistant = async () => {
            setLoading(true);
            setError(null);
            const result = await AssistantService.getInstructions();
            if (result instanceof Error) {
                setError(result.message);
            } else {
                setAssistant(result);
                setInstructions(result.instructions ?? "");
            }
            setLoading(false);
        };
        fetchAssistant();
    }, []);

    const handleSave = async () => {
        if (!assistant) return;
        setSaving(true);
        setError(null);
        setSuccess(false);

        const updatedAssistant: Assistant = {
            id: assistant.id,
            name: assistant.name,
            instructions: instructions
        };

        const result = await AssistantService.setInstructions(updatedAssistant);
        if (result instanceof Error) {
            setError(result.message);
        } else {
            setSuccess(true);
        }
        setSaving(false);
    };

    return (
        <div style={{ maxWidth: 800 }}>
            <h3>Configuración de Asistente IA</h3>
            {loading ? (
                <div>Cargando...</div>
            ) : assistant ? (
                <>
                    <div>
                        <strong>ID:</strong> {assistant.id}
                    </div>
                    <div>
                        <strong>Nombre:</strong> {assistant.name}
                    </div>
                    <div>
                        <strong>Instrucciones:</strong>
                        <textarea
                            style={{ width: "100%", minHeight: 600 }}
                            value={instructions}
                            onChange={e => setInstructions(e.target.value)}
                            disabled={saving}
                        />
                    </div>
                    <div style={{ marginTop: 10 }}>
                        <button className="btn btn-primary" onClick={handleSave} disabled={saving}>
                            Guardar
                        </button>
                        {saving && <span style={{ marginLeft: 10 }}>Guardando...</span>}
                        {success && <span style={{ marginLeft: 10, color: "green" }}>¡Guardado!</span>}
                        {error && <span style={{ marginLeft: 10, color: "red" }}>{error}</span>}
                    </div>
                </>
            ) : (
                <div>No se encontró información del asistente.</div>
            )}
        </div>
    );
};

export default AssistantConfiguration;